export { default as MaterialsIndexPageCategoriesNavBody } from './MaterialsIndexPageCategoriesNavBody';
